import { FilterMode } from "./types";

export const FILTER_MODE: Record<string, FilterMode> = {
  ANY: "ANY_PRESENT",
  ALL: "ALL_PRESENT",
  NONE: "NONE_PRESENT",
};
